//This is a modal that highlights the dom element passed while fading everything else out and popping up a modal with the information provided

import React from 'react';
import {Button}  from '../generic/button.js';
import {Container} from '../generic/container.js';

class HighlightModal extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);

	}

	onClick(e) {
		if(this.props.onClick) this.props.onClick(e);
	}

	render() {
		var modalSize = {
			width: this.props.size ? this.props.size.width : '50vmin',
			height: this.props.size ? this.props.size.height : 'auto'
		};
		var additionalClass = this.props.visible ? ' Visible' : ' Hidden';
		var affirmativeLabel = this.props.affirmativeLabel || 'Okay';
		const content = this.props.content;

		////console.log(this.props.highlight);

		if(this.props.highlight) {

			if(this.props.visible) this.props.highlight.addClass('highlight');
			else this.props.highlight.removeClass('highlight');
		}

		var containerContents = (

			<div className={"ModalContents"}>
				{content}
				<div className={"ModalButtons-Col Highlight-Button"}>
					<div className={"ModalButton-Affirmative"}>
						<Button class="Affirmative-Button" dataId="affirmative" label={affirmativeLabel} onClick={this.onClick} />
					</div>
				</div>
			</div> 
		);

		return (
			<div className={"Modal HighlightModal" + additionalClass}>
				<Container size={modalSize} moreTitleClass={"highlight-container"} titles={[{label: this.props.header}]} contents={containerContents} bgcolor="#ffffff" nogradient={true} />
			</div>
		);


	}
}

export default HighlightModal;